/*
*###############################################################################
*Module Name                   : DPPermission.js                               #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  Minol Prageesha                              #
*Date                          : Friday, October 29th 2021, 11:08:32 am        #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useEffect, useState } from 'react';
import { Modal, ModalBody, Form, FormGroup, Input, Label, Button, Alert } from "reactstrap";
import avatar from "assets/images/users/uac-shield.png";
import Config, { ActiveClient } from "../../config";
import './DPPermission.css';

const DPPermission = (props) => {
    const { isOpen = false, confirm_both = false, onConfirm, onCancel, title, showCancel, btnYes, btnNo, btnColor, showReason
        , AlName, AlNameOnchange, AlPassward, AlPasswardOnchange, AlReason, AlReasonOnchange
    } = props;
    const [modalOpen, setModalOpen] = useState(false);
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);    useEffect(() => {
        // Check both isOpen and confirm_both for backwards compatibility
        setModalOpen(isOpen || confirm_both || false);
        setIsLoading(false);
        
        // Debug: Log color value when component updates
        if (props.show) {
            console.log('Alert Color:', props.AlertColor);
        }
    }, [isOpen, confirm_both, props.show, props.AlertColor]);

    const handleCancel = () => {
        setModalOpen(false);


        setError("");
        if (onCancel) onCancel();
    };

    const handleConfirm = async () => {
        if (!AlName || !AlPassward) {
            setError("Please enter both username and password");
            return;
        }
        if (showReason && !AlReason) {
            setError("Please provide a reason");
            return;
        }

        setIsLoading(true);
        setError("");

        try {

            if (onConfirm) {
                await onConfirm();
            }
            
        } catch (err) {
            setError(err.message || "Authentication failed");
        } finally {
            //setIsLoading(false);
        }
    };

    return (
        <Modal
            isOpen={modalOpen}
            toggle={handleCancel}
            centered
            size="md"
            className="auth-dialog"
            backdrop="static"
        >
            <ModalBody className="px-4 py-4">
                <div className="text-center mb-4">
                    <img src={avatar} alt="UAC Shield" height="42" className="mb-3" />
                    <h5 className="mb-2">{title || "Authentication Required"}</h5>
                    <p className="text-muted mb-2">
                        {props.description}
                    </p>
                    <p className="text-muted mb-0">
                        You do not have the necessary permissions to perform this action.
                        To proceed, please enter the credentials of an authorized user.
                        If you believe you should have access or need someone else to perform this action, please contact your supervisor or system administrator to request the appropriate permissions
                    </p>                </div>                  {props.show && props.AlertMsg && (
                    <Alert 
                        color={props.AlertColor || "danger"} 
                        className="mb-3"
                    >
                        {props.AlertMsg}
                    </Alert>
                )}

                {error && (
                    <Alert 
                        color="danger" 
                        className="mb-3"
                    >
                        {error}
                    </Alert>
                )}

                <Form>
                    <FormGroup className="mb-3">
                        <div className="input-group input-group-sm rounded">
                            <span className="input-group-text">
                                <i className="mdi mdi-account-outline"></i>
                            </span>
                            <Input
                                type="text"
                                className="form-control form-control-sm"
                                id="username"
                                value={AlName}
                                onChange={AlNameOnchange}
                                placeholder="Username"
                                bsSize="sm"
                                autoComplete="off"
                            />
                        </div>
                    </FormGroup>

                    <FormGroup className="mb-3">
                        <div className="input-group input-group-sm rounded">
                            <span className="input-group-text">
                                <i className="mdi mdi-lock-outline"></i>
                            </span>
                            <Input
                                type="password"
                                className="form-control form-control-sm"
                                id="password"
                                value={AlPassward}
                                onChange={AlPasswardOnchange}
                                placeholder="Password"
                                bsSize="sm"
                                autoComplete="new-password"
                            />
                        </div>
                    </FormGroup>

                    {showReason && <FormGroup className="mb-3">
                        <div className="input-group input-group-sm rounded">
                            <span className="input-group-text">
                                <i className="mdi mdi-comment-text-outline"></i>
                            </span>
                            <Input
                                type="text"
                                className="form-control form-control-sm"
                                id="reason"
                                value={AlReason}
                                onChange={AlReasonOnchange}
                                placeholder="Reason"
                                bsSize="sm"
                            />
                        </div>
                    </FormGroup>}

                    <div className="d-flex gap-2 mt-4">
                        <Button
                            color={btnColor || 'primary'}
                            size="sm"
                            className="flex-fill py-2"
                            onClick={handleConfirm}
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <><i className="mdi mdi-loading mdi-spin me-1"></i>Authenticating...</>
                            ) : (
                                <><i className="mdi mdi-check me-1"></i>{btnYes || 'Authorize'}</>
                            )}
                        </Button>
                        {showCancel && (
                            <Button
                                color="light"
                                size="sm"
                                className="flex-fill py-2"
                                onClick={handleCancel}
                                disabled={isLoading}
                            >
                                <i className="mdi mdi-close me-1"></i>
                                {btnNo || 'Cancel'}
                            </Button>
                        )}
                    </div>
                </Form>
            </ModalBody>
        </Modal>
    );
}

export default DPPermission;